export default __webpack_public_path__ + "static/media/front_sura.cecf1b27.svg";